module.exports = __webpack_public_path__ + "images/bannerIT-02ff9009454637511e4be5f0eaf862a7.png";